import React, { FC, useCallback, useEffect, useState, useContext } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Select,
    Grid,
    MenuItem,
    Tooltip,
    IconButton,
    withStyles,
    Dialog, DialogActions,
    DialogContent, DialogContentText,
    DialogTitle
} from "@material-ui/core";
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { ArrowBack } from '@material-ui/icons';
import { useParams } from "react-router";
import Typography from '@material-ui/core/Typography';
import SFIARPToolbar from '../components/toolbar';
import { API_URL } from "../env";
import {
    IProjectUser, IUserAdmin
} from "../types/types";
import { get, post, del } from "../fetchers/fetchers";



const useStyles = makeStyles({
    tableHeader: {
        backgroundColor: 'lightgrey',
    },
    tableHeaderCell: {
        textAlign: 'center',
    },
});

interface IAdminProps { }

interface IRouteParams {
    id: string
}

const AddingButton = withStyles(theme => ({
    root: {
        margin: "auto",
        backgroundColor: "rgba(0,103,114,0.2)",
        color: "rgba(0,103,114,1)",
        '&:hover': {
            backgroundColor: "rgba(0,103,114,0.5)",
        },
    },
}))(IconButton);


const ProjectAdmin: FC<IAdminProps> = () => {
    const classes = useStyles();
    const params = useParams<IRouteParams>()

    const [users, setUsers] = useState<IUserAdmin[]>([]);
    const [projectUsers, setProjectUsers] = useState<IProjectUser[]>([]);
    const [reloadUsers, setReloadUsers] = useState<boolean>(false)
    const [openUserAddDialog, setOpenUserAddDialog] = useState<boolean>(false);
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
    const [selectedAccessLevel, setSelectedAccessLevel] = useState<number | null>(null);

    const accessLevels = [
        { assess_level: 1, name: "Demo" },
        { assess_level: 2, name: "Read" },
        { assess_level: 3, name: "Write" },
        { assess_level: 4, name: "Admin" },
        { assess_level: 5, name: "Owner" }
    ]

    const getProjectUsers = async () => {
        return await get<IProjectUser[]>(API_URL + "projects/" + params.id + "/users");
    }

    const getUsers = async () => {
        return await get<IUserAdmin[]>(API_URL + "user/");
    }

    const updateRole = async (user_id: number, role_id: number) => {
        let payload = {
            user_id: user_id,
            role_id: role_id
        }
        return await post<any>(API_URL + "/user/role/", payload)
    }

    const handleRoleChange = (user_id: number, event: React.ChangeEvent<{ value: unknown }>) => {
        const role_id = event.target.value as number;

        updateRole(user_id, role_id).then(() =>
            setReloadUsers(true)
        )
    };



    useEffect(() => {
        Promise.all([getProjectUsers(), getUsers()]).then(([projectUsers, users]) => {
            setProjectUsers(projectUsers);
            setUsers(users);
        });
    }, []);

    useEffect(() => {
        if (reloadUsers) {
            setReloadUsers(false)
            getProjectUsers().then((users) => {
                setProjectUsers(users)
            }
            )
        }
    }, [reloadUsers, setReloadUsers]
    )

    const handleClose = () => {
        setOpenUserAddDialog(false)
    }

    const handleOpen = () => {
        setOpenUserAddDialog(true)
    }

    const postUserRole = async (user_id: number, access_level: number) => {
        let payload = {
            user_id: user_id,
            access_level: access_level
        }
        return await post<any>(API_URL + "projects/" + params.id + "/users", payload);
    }

    const delUserRole = async (user_id: number) => {

        return await del<any>(API_URL + "projects/" + params.id + "/users/" + user_id );
    }

    const handleAddUser = () => {
        if (selectedUserId !== null && selectedAccessLevel !== null) {
            postUserRole(selectedUserId, selectedAccessLevel).then(() => {
                handleClose();
                setReloadUsers(true);
            });
        }
    }
    const handleRemoveUser = (user_id: number) => {
        console.log("user_id", user_id)
        delUserRole(user_id).then(() => {
            setReloadUsers(true);
        });
    }

    const handleBack = () => {
        window.history.back();
    }


    const create_select_user_dialog = () => {

        // filtered users that are not already in the project
        const filtered_users = users.filter(user => !projectUsers.some(projectUser => projectUser.user_id === user.id))

        return (
            <Dialog open={openUserAddDialog} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add User</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Select user to add to project
                        </Typography>
                        <Select
                            onChange={(e) => setSelectedUserId(e.target.value as number)}
                        >
                            {filtered_users.map(user => (
                                <MenuItem key={user.id} value={user.id}>
                                    {user.email}
                                </MenuItem>
                            ))}
                        </Select>
                        <Select
                            onChange={(e) => setSelectedAccessLevel(e.target.value as number)}>
                            {accessLevels.map(accessLevel => (
                                <MenuItem key={accessLevel.assess_level} value={accessLevel.assess_level}>
                                    {accessLevel.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAddUser} color="primary">
                        Add
                    </Button>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>

                </DialogActions>
            </Dialog>
        )
    }


    return (
        <>
        <SFIARPToolbar title={"Project users"}/>
        <Container>
            {create_select_user_dialog()}
            <Grid container spacing={3} xl={12} direction="row" style={{ padding: "20px", marginTop: "40px" }}>
                <Grid item xs={5} sm={3} md={2} lg={2}>
                    <div style={{ position: "sticky", top: "68px" }}>
                        <Tooltip title="Back" placement={'bottom-end'}>
                            <AddingButton style={{ backgroundColor: "rgb(239,88,43)", color: "#FFFFFF" }} onClick={prevState => handleBack()} >
                                <ArrowBack />
                            </AddingButton>
                        </Tooltip>
                        <br />
                        <Tooltip title="Create new project" placement={'bottom-end'}>
                            <AddingButton style={{ backgroundColor: "rgb(239,88,43)", color: "#FFFFFF" }} onClick={prevState => handleOpen()} >
                                <AddIcon />
                            </AddingButton>
                        </Tooltip>
                        <br />
                    </div>
                </Grid>
                <Grid item xs={7} sm={9} md={9} lg={10} container spacing={3}>

                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableHeaderCell} >Email</TableCell>
                                    <TableCell className={classes.tableHeaderCell} >Access Level </TableCell>
                                    <TableCell className={classes.tableHeaderCell} > Action </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {projectUsers.map((user) => (
                                    <TableRow key={user.id}>
                                        <TableCell>{user.user?.email}</TableCell>
                                        <TableCell>
                                            {accessLevels.filter(accessLevel => accessLevel.assess_level === user.access_level)[0].name}
                                        </TableCell>
                                        <TableCell>
                                            <Button variant="outlined" size="small" onClick={prevState => handleRemoveUser(user.user_id|| -1)}>Remove</Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Container>
        </>
    );
}

export default ProjectAdmin;
